


import IHasChildren from '@/types/components/IHasChildren';
import { CircularProgress, TextField, TextFieldProps } from '@mui/material';
import { FC, useState } from 'react';
import Center from './Center';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { grey } from '@mui/material/colors';
import { faCaretUp } from '@fortawesome/pro-duotone-svg-icons';


type SelectProps = TextFieldProps & IHasChildren & {
    loading?: boolean;
};

const Select: FC<SelectProps> = ({
    loading,
    children,
    ...rest
}) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <TextField
            {...rest}
            SelectProps={{
                ...rest.SelectProps,
                onOpen: () => setOpen(true),
                onClose: () => setOpen(false),
                IconComponent: () => null
            }}
            InputProps={{
                ...rest.InputProps,
                endAdornment: true ? (
                    <Center width='0px'>
                        {
                            loading && 
                            <CircularProgress sx={{ position: 'absolute', right: '12px', color: grey[500], maxWidth: '16px', maxHeight: '16px' }} />
                        }
                        <FontAwesomeIcon 
                            style={{
                                position: 'absolute',
                                right: '15px',
                                rotate: open ? '180deg' : '0deg'
                            }}
                            color={grey[600]} 
                            icon={faCaretUp} 
                        />
                    </Center>
                ) : undefined
            }}
            InputLabelProps={{
                ...rest.InputLabelProps,
                shrink: true
            }}
        >
            {children}
        </TextField>
    )
}

export default Select